/**
 * Musical Constants
 * Centralizes musical timing, BPM limits, and division calculations.
 */
export const MUSICAL_CONSTANTS = {
  bpm: {
    min: 1,
    max: 300,
    default: 120,
    slowMin: 60,
    fastMax: 180,
    extremeMax: 200
  },

  timeSignature: {
    beatsPerBar: 4,
    noteValue: 4,
    subdivision: 16
  },

  divisions: {
    '64th': 0.0625,
    '32nd': 0.125,
    '16th': 0.25,
    '8th': 0.5,
    'quarter': 1,
    'half': 2,
    'whole': 4,
    '1bar': 4,
    '2bars': 8,
    '4bars': 16,
    '8bars': 32,
    '16bars': 64
  },

  sync: {
    tolerance: 0.01,
    beatTolerance: 0.05,
    barTolerance: 0.02,
    quantizeStrength: 0.8
  },

  defaultDivisions: {
    movement: '8th',
    rotation: 'quarter',
    scaling: 'half',
    morphing: '2bars',
    lighting: '4bars',
    effects: '16th'
  }
};

/**
 * Audio Processing Constants
 * Centralizes audio analysis parameters and processing settings.
 */
export const AUDIO_PROCESSING = {
  fft: {
    size: 2048,
    smoothing: 0.8,
    minSize: 256,
    maxSize: 8192,
    defaultSize: 2048
  },

  sampleRates: {
    min: 22050,
    ideal: 44100,
    max: 48000,
    lowQuality: 16000,
    highQuality: 96000
  },

  channels: {
    min: 1,
    ideal: 2,
    max: 8,
    default: 2
  },

  smoothing: {
    lerpFactor: 0.1,
    temporalSmoothing: 0.8,
    spatialSmoothing: 0.3,
    peakDecay: 0.95,
    noiseGate: 0.01
  },

  normalization: {
    midiCenter: 128,
    midiMax: 255,
    audioMax: 1.0,
    audioMin: -1.0,
    dbRange: 60
  },

  frequencyBands: {
    bass: { min: 20, max: 250, center: 80 },
    mid: { min: 250, max: 4000, center: 1000 },
    treble: { min: 4000, max: 20000, center: 8000 },
    subBass: { min: 20, max: 60, center: 40 },
    presence: { min: 2000, max: 8000, center: 4000 }
  },

  sensitivity: {
    low: 0.3,
    medium: 0.6,
    high: 1.0,
    extreme: 1.5,
    default: 0.6
  }
};
